import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import InputGroup from 'react-bootstrap/InputGroup';
import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";
import '../css/keppin.css';
import '../css/paste.css';
import settings from '../../assets/settings.json';

import {addPartsFunction} from './PartsFunction';
import {addCmListFunction} from './CmListFunction';
import Cookies from 'js-cookie'



export default class KeppinList extends Component{
  
  constructor(){
    super();

    let default_tabel_data = [[{value: "KEY"}, {value: "管理番号"},{value: "明細行"},{value: "JAN"},{value: "カラー"},{value: "サイズ"},{value: "集計"}]];
    let i =0;
    while(i<10){
      default_tabel_data.push([{ value: "" }, { value: "" },{ value: "" },{ value: "" },{ value: "" },{ value: "" },{ value: "" }]);
      i++;
    };

    this.state={
      isOpen: false,
      table_data: default_tabel_data,
      loading_icon:false
    }
  }

  
  componentDidMount () {
    //console.dir(this.props.data);
  


  }
  
  openModal = () => {
    this.setState({ isOpen: true });
    this.setState({loading_icon:true});

    if(this.props.data.auth_obj.staff_token===undefined){
      this.props.data.auth_obj.staff_token = Cookies.get('_replace_token');
      this.props.data.auth_obj.staff_name = Cookies.get('_replace_staff');
    }


    let api_url = settings.API_BASE_URL + 'cm_order_list/' +'?token='+this.props.data.auth_obj.staff_token+'&name='+this.props.data.auth_obj.staff_name+'&hit=欠品リスト&phase=完了以外&JAN=all&cm_order_no=all&_from='+ this.props.data.fromToObj.from+'&_to='+this.props.data.fromToObj.to+'&hattyuu_no=all&order_key=all';
    console.log('api_url:'+api_url);
		fetch(api_url)
      .then(res => res.json())
      .then(json =>{
				console.log(json.data.obj); 

        let tabel_data = [[{value: "KEY"}, {value: "管理番号"},{value: "明細行"},{value: "JAN"},{value: "カラー"},{value: "サイズ"},{value: "集計"}]];
        let i =0;
        while(i<(json.data.obj.length)){
          tabel_data.push([{ value: json.data.obj[i].order_key }, { value: json.data.obj[i].cm_order_no },{ value: json.data.obj[i].meisai_gyou },{ value: json.data.obj[i].JAN },{ value: json.data.obj[i].size_type },{ value: json.data.obj[i].color_type },{ value: json.data.obj[i].hattyuu_howmany }]);
          i++;
        };

        this.setState({table_data:tabel_data});
        this.setState({loading_icon:false});
      });


  }

  closeModal = () => {
    this.setState({ isOpen: false });
  }
  


  

  
    
  render(){
    let button_class = '';
    if(this.state.isOpen){
      button_class = 'btn btn-sm btn-warning a-small sheet_close_button';
    }else{
      button_class = 'btn btn-sm btn-warning a-small';

    }

    return (


        
      <div className={this.state.isOpen ? "keppin_list keppin_list_border" : "keppin_list"}>
        <div className={button_class} >
          {this.state.isOpen ? <div onClick={this.closeModal}>閉じる</div> : <div onClick={this.openModal}>欠品リスト取得</div>}
        </div>
          
        {this.state.isOpen ? 
          <>
            <div className="keppin_list_table">
              <div>
                {this.state.loading_icon ? 
                  <><div className="spinner-border spinner-border-sm mx-1 loadding-keppin" role="status"><span className="sr-only"></span></div></> 
                  : 
                  <>From:{this.props.data.fromToObj.from}　〜　To:{this.props.data.fromToObj.to}</>}
              </div>

              <Spreadsheet 
                data={this.state.table_data} 
                className=""
              />

            </div>
          </> 
          : <></>
        }

        
        
      </div>
    );
  }
}
  
  

	//{...this.props}